import { render, staticRenderFns } from "./pk_lv_1.vue?vue&type=template&id=a3c9f09c&"
import script from "./pk_lv_1.vue?vue&type=script&lang=js&"
export * from "./pk_lv_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports